import { render, staticRenderFns } from "./ListStaffPage.vue?vue&type=template&id=c2f44e12&"
import script from "./ListStaffPage.vue?vue&type=script&lang=js&"
export * from "./ListStaffPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports